import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthHeaderConverter extends CmsConverterService<FullWidthHeaderData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_title_text?.value
    const altText = formData.st_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: {
        ...CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText, title),
        pointOfImage: formData.st_header_image_point_of_image?.value?.identifier ?? '',
      },
      buttonLeft: {
        blue: formData.st_button_left_blue_style?.value ?? false,
        show: formData.st_button_left_show?.value ?? false,
        ...formData.st_button_left_link ?? defaultLinkData,
      },
      buttonRight: {
        blue: formData.st_button_right_blue_style?.value ?? false,
        show: formData.st_button_right_show?.value ?? false,
        ...formData.st_button_right_link ?? defaultLinkData,
      },
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput
    }
  }
}

export const FULL_WIDTH_HEADER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, FullWidthHeaderData>>(
  'FullWidthHeaderConverter')

export interface FullWidthHeaderData extends ConvertedComponentData {
  buttonLeft: FullWidthHeaderButtonData;
  buttonRight: FullWidthHeaderButtonData;
  image: FullWithHeaderImageData;
  headline: TextInput;
  text: TextInput;
}

export interface FullWidthHeaderButtonData extends LinkData {
  blue: boolean;
  show: boolean;
}

export interface FullWithHeaderImageData extends Image {
  pointOfImage: string;
}
